import { React,useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import "./Contactus.css";

    const ContactForm = () => {
        const [validated, setValidated] = useState(false);
    
        const handleSubmit = (event) => {
            event.preventDefault();
    
            const form = event.currentTarget;
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }
    
            setValidated(true);
        };
    
        return (
            <Form noValidate validated={validated} onSubmit={handleSubmit} className="contact-form">
            <Form.Group className="mb-3">
                <Form.Control type="text" placeholder="Enter Name" required />
                <Form.Control.Feedback type="invalid">
                    Please enter your name.
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Control type="email" placeholder="Enter Email" required />
                <Form.Control.Feedback type="invalid">
                    Please enter a valid email.
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-4">
                <Form.Control as="textarea" rows={4} placeholder="Enter Message" required />
                <Form.Control.Feedback type="invalid">
                    Please enter your message.
                </Form.Control.Feedback>
            </Form.Group>
            <div className="d-grid">
                <Button variant="" type="submit" className="btn btn-outline-warning">
                    Submit
                </Button>
            </div>
        </Form>
        );
    };
    
    const ContactFormCard = () => (
        <Card className="contact-card shadow-lg">
        <Card.Body>
            <h2 className="mb-4">Contact Us</h2>
            <p className="mb-4">
                We list your menu online, help you process orders and answer your questions.
            </p>
            <ContactForm />
        </Card.Body>
    </Card>
    );
    
export const Contactus = () => {
        return (
          
            <Container fluid className="contact-section py-5">
            <Row className="g-4 align-items-center">
                <Col xs={12} md={6} className="text-center text-md-start">
                    <h2 className="mb-3">How can we help you?</h2>
                    <p className="mb-4">
                        It’s easier to reach your savings goals when you have the right
                        savings account. Take a look and find the right one for you!
                    </p>
                    <div className="map-container">
                        {/* Replace this with an embedded map */}
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7454289.681322997!2d69.7220125265859!3d24.179100650924177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3914a196975ad85f%3A0xf9f91ef2a24c5007!2sShree%20Shyam%20Enterprises!5e0!3m2!1sen!2sin!4v1745678237851!5m2!1sen!2sin"
                            width="100%"
                            height="250"
                            allowFullScreen=""
                            loading="lazy"
                            title="Company Location"
                            style={{ border: "0", borderRadius: "12px" }}
                        ></iframe>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <ContactFormCard />
                </Col>
            </Row>
        </Container>
        );
    };
